<!--
 * @Author: your name
 * @Date: 2022-02-28 18:04:09
 * @LastEditTime: 2022-03-07 20:49:03
 * @LastEditors: Please set LastEditors
 * @Description: 合同 —— 实名认证 —— 认证方式
 * @FilePath: \wx-front\src\components\contract\authenticationMode.vue
-->
<template>
    <div class="wrap">
        <div class="pageTitle">实名认证</div>
        <div class="pageTips">应电子合同相关法律要求，当前操作需要进行本人实名认证，以确保本人意愿。旭课保证您的个人信息仅用于确认本人身份。</div>
        <!-- 手机号认证 -->
        <div class="modeItem" @click="clickPhone">
            <div class="rowJbAc">
                <div class="rowAc">
                    <img src="../../assets/static/contract/phoneBox.svg" alt="" class="modeImg">
                    <div class="modeName fontScN8 fontH1">手机号认证</div>
                </div>
                <div class="icon-arrow-left leftIcon"></div>
            </div>
            <div class="modeTips fontScN6 fontH3">仅支持大陆人士认证，请确保手机号为本人身份证在运营商处办理</div>
        </div>
        <!-- 底部 -->
        <div class="bottom fontH4">
            <span class="fontScN6">使用认证服务即同意&nbsp;</span>
            <span class="fontScN7">电子签服务协议&nbsp;</span>
            <span class="fontScN6">和&nbsp;</span>
            <span class="fontScN7">隐私声明&nbsp;</span>
            <span class="fontScN6">和&nbsp;</span>
            <span class="fontScN7">数字证书申请协议</span>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        // 点击手机号认证
        clickPhone() {
            this.$router.push('/phoneAuthentication')
        }
    }
}
</script>
<style lang="scss" scoped>
.wrap {
    width: 100%;
    height: 100%;
    padding: .32rem .16rem 0;
    box-sizing: border-box;
    background: #F5F6F9;
    position: relative;
}
.pageTitle {
    font-size: .26rem;
    font-weight: 500;
    color: #191C27;
    line-height: .37rem;
    padding-left: .08rem;
}
.pageTips {
    font-size: .14rem;
    font-weight: 400;
    color: #9EA5BB;
    line-height: .21rem;
    margin: .12rem 0 .24rem 0;
    padding-left: .08rem;
}
.modeItem {
    background: #FFFFFF;
    border-radius: .12rem;
    padding: .16rem;
}
.modeImg {
    width: .4rem;
    height: .4rem;
    margin-right: .12rem;
}
.leftIcon {
    font-size: .16rem;
    color: #969799;
}
.modeTips {
    margin-top: .12rem;
}
.bottom {
    width: 100%;
    position: absolute;
    bottom: .4rem;
    left: 0;
    padding: 0 .24rem;
    box-sizing: border-box;
}
</style>
